export default {
  title: 'Ekskluzywne oferty',
  header: {
    back: 'Wstecz',
    title: 'Nagrody',
  },
  info: {
    title: 'Masz {{points}} punktów.',
    description:
      'Wydaj {{amount}}, aby zdobyć 5 punktów! Dodaj produkty do koszyka bezpłatnie dzięki zdobytym punktom.',
  },
  rewards: {
    data: [
      {
        title: 'Zdobywaj punkty za każde zamówienie',
        description: 'Każde wydane {{amount}} dodaje 5 punktów do Twojego konta.',
      },
      {
        title: 'Zdobywaj punkty za każde zamówienie',
        description:
          'Wymień punkty na darmowe nagrody! Zacznij korzystać z punktów od 350 punktów, co odpowiada wydaniu {{amount}}.',
      },
      {
        title: 'Zdobywaj punkty za każde zamówienie',
        description: 'Odkryj ekskluzywne oferty, promocje i rabaty. Sprawdź oferty tylko dla członków w aplikacji.',
      },
    ],
  },
};
